import { connect } from 'react-redux';
import { createList, addListError, clearProducts } from 'Favourites/store/actions';

import {
    selectNewListError,
} from 'store/reducers/data/shoppingList';

import { LIST_TYPE } from 'Favourites/store/constants';

const mapStateToProps = (state) => {
    return {
        error: selectNewListError(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addShoppingList: (name) => {
            dispatch(createList(name, LIST_TYPE, [], false, false));
            dispatch(clearProducts());
        },
        setError: (error = false) => {
            dispatch(addListError(error));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
